import { format, parseISO } from 'date-fns';
import type React from 'react';

import * as st from './Data.module.scss';

type Props = {
	type: string;
	start: string;
	status?: React.ReactElement;
};

const modes: { [x: string]: string } = {
	ON: 'Online',
	OF: 'Личный прием',
};

const Data: React.FC<Props> = ({ type, start, status }) => {
	return (
		<div className={st.data}>
			<h4>{modes[type]}</h4>
			<div className={st.data__bottom}>
				<p>
					<span>{format(parseISO(start), 'dd.MM.yyyy')}</span>
					<span>, </span>
					<span>{format(parseISO(start), 'HH:mm')}</span>
				</p>
				<span>{status}</span>
			</div>
		</div>
	);
};

export default Data;
